import React from 'react'
import { Box, Button, Card, CardActionArea, CardActions, CardContent, Dialog, Stack, Typography } from '@mui/material'
import DataTable, { DataTableCabecalhoInterface } from '../../../DevComponents/DataTable'

interface ModalComponentInterface {
  exibir: boolean
  setExibir: React.Dispatch<React.SetStateAction<any>>
}

export default function HelpTeclas({ exibir, setExibir }: ModalComponentInterface) {

  const Cabecalho: Array<DataTableCabecalhoInterface> = [{
    campo: 'tecla',
    cabecalho: 'Tecla'
  }, {
    campo: 'descricao',
    cabecalho: 'Descrição'
  }]

  const rsDados = [
    {
      'tecla': 'TAB',
      'descricao': 'Ir para a Direita'
    },
    {
      'tecla': 'SHIFT + TAB',
      'descricao': 'Ir para a Esquerda'
    },
    {
      'tecla': 'ALT + T',
      'descricao': 'Copiar a linha atual para todas as outras'
    },
    {
      'tecla': 'ALT + C',
      'descricao': 'Copiar célula atual para a coluna inteira'
    },
    {
      'tecla': 'CTRL + ALT + <n>',
      'descricao': 'Copia O CAMPO da linha anterior de número n (1 a 9) para o CAMPO atual'
    },
    {
      'tecla': 'ALT + <n>',
      'descricao': 'Copia O REGISTRO da linha anterior de número n (1 a 9) para o REGISTRO atual'
    },
    {
      'tecla': 'ENTER ou F2',
      'descricao': 'Permite alterar o Campo Atual'
    },
    {
      'tecla': 'ENTER ou ESC',
      'descricao': 'Encerra a edição do Campo Atual'
    },
    {
      'tecla': 'DEL',
      'descricao': 'Apaga Conteudo do Campo Atual'
    },
    {
      'tecla': 'ALT + DEL',
      'descricao': 'Apaga Tudo! Cuidado!'
    },
  ]

  return (
    <>
      <Dialog
        fullWidth
        onClose={() => {
          setExibir(false)
        }}
        open={exibir}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Card >
          <CardActionArea>
            <CardContent>

              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>


                <Typography gutterBottom variant="h5" component="div">
                  Teclas
                </Typography>

                <Button size="small" color="primary" onClick={() => setExibir(false)}>
                  Fechar
                </Button>

              </Box>
              <DataTable
                dados={rsDados}
                cabecalho={Cabecalho}
                acoes={[]} />
            </CardContent>
          </CardActionArea>
          s        </Card>
      </Dialog>
    </>
  )

}